import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { RegraFreteCriarComponent } from "./pages/criar/criar-regra-frete.component";
import { RegraFreteEditarComponent } from "./pages/editar/editar-regra-frete.component";
import { ListarRegraFreteComponent } from "./pages/listar/listar.component";

const routes: Routes = [
  {
    path: "configuracoes-do-usuario/regra-frete",
    component: ListarRegraFreteComponent,
  },
  {
    path: "configuracoes-do-usuario/regra-frete/criar/:id",
    component: RegraFreteCriarComponent,
  },
  {
    path: "configuracoes-do-usuario/regra-frete/editar/:id",
    component: RegraFreteEditarComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class RelatoriosRoutingModule {}
